import api from './api';

const walletService = {
  async getWallet() {
    try {
      const res = await api.get('/wallet');
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to load wallet' };
    }
  },

  async initiateTopUp(amount) {
    try {
      const res = await api.post('/wallet/topup/initiate', { amount });
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to initiate top-up' };
    }
  },

  async verifyTopUp(payload) {
    try {
      const res = await api.post('/wallet/topup/verify', payload);
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to verify payment' };
    }
  },

  async payWithWallet(orderId) {
    try {
      const res = await api.post('/wallet/pay-order', { orderId });
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Wallet payment failed' };
    }
  },

  async debitForOrder(orderId, walletAmount) {
    try {
      const res = await api.post('/wallet/debit-for-order', { orderId, walletAmount });
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Wallet debit failed' };
    }
  },

  async getAdminWalletHistory(userId) {
    try {
      const res = await api.get(`/admin/wallet/history/${userId}`);
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to load wallet history' };
    }
  },

  async adminCreditWallet(userId, amount, note = '', complaintId = null) {
    try {
      const body = { amount, note };
      if (complaintId) body.complaintId = complaintId;
      const res = await api.post(`/admin/wallet/credit/${userId}`, body);
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to credit wallet' };
    }
  },

  // Admin "Debit BMF Coins" — standalone deduction against an external bank
  // transfer (BMF-BRD-2026-014). All fields mandatory.
  async adminDebitWallet(userId, { amount, transactionRefId, description, category }) {
    try {
      const res = await api.post(`/admin/wallet/debit/${userId}`, {
        amount,
        transactionRefId: typeof transactionRefId === 'string' ? transactionRefId.trim() : transactionRefId,
        description: typeof description === 'string' ? description.trim() : description,
        category: typeof category === 'string' ? category.trim() : category,
      });
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to debit wallet' };
    }
  },

  async getCoinsOverview() {
    try {
      const res = await api.get('/admin/wallet/coins/overview');
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to load coin stats' };
    }
  },

  async getCoinTransactions(params) {
    try {
      const res = await api.get('/admin/wallet/coins/transactions', { params });
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: err.response?.data?.message || 'Failed to load coin history' };
    }
  },
};

export default walletService;
